<style src="./Login.scss" lang="scss"></style>
<template>
  <div class="login-wrapper gray-bg">
    <div class="middle-box text-center loginscreen animated fadeInDown">
      <spinner size="large" message="Aguarde..." v-if="showSpinner"> </spinner>

      <div class="image-logo">
        <h1 class="name">Peace Parking</h1>
      </div>

      <FormValidate class="m-t" role="form" @submit="login" v-slot="{ errors }">
        <div class="form-group">
          <Field
            as="input"
            type="text"
            name="cpf"
            class="form-control login-text"
            placeholder="CPF"
            v-model="credentials.cpf"
            rules="required"
            :class="{ invalid: errors.cpf }"
          />
          <span class="error">{{ errors.cpf }}</span>
        </div>

        <div class="form-group">
          <Field
            as="input"
            :type="fieldType"
            name="password"
            class="form-control input-btn login-text"
            placeholder="Senha"
            v-model="credentials.password"
            rules="required|min:4"
            :class="{ invalid: errors.password }"
          />
          <span class="error">{{ errors.password }}</span>
        </div>

        <div class="alert alert-danger" v-if="wrongUserOrPassword">
          Usuário ou senha incorreto. Tente novamente.
        </div>

        <br />

        <button type="submit" class="btn btn-login btn-block">Entrar</button>

        <!-- <div class="text-center">
          <button type="button" class="btn btn-link">
            <router-link to="/forgot-password"
              ><small>Esqueci a senha</small></router-link
            >
          </button>
        </div> -->
      </FormValidate>

      <p class="m-t">
        <small>Peace Parking &copy; {{ year }} - v4.6.0</small>
      </p>
    </div>
  </div>
</template>

<script>
import Spinner from '@/components/Spinner';
import { Form as FormValidate, Field } from 'vee-validate';

export default {
  components: { Spinner, FormValidate, Field },
  data() {
    return {
      credentials: {
        cpf: '',
        password: '',
      },
      showSpinner: false,
      fieldType: 'password',
      year: new Date().getFullYear(),
      wrongUserOrPassword: false,
    };
  },
  mounted() {
    this.$store.commit('DATA-ACCESS/setUserToken', null);
  },
  methods: {
    async login() {
      try {
        await this.$store.dispatch('DATA-ACCESS/doLogin', this.credentials);
        this.$store.dispatch('MESSAGES/WatchMonitor');
        this.$router.push({ name: 'Welcome' });
      } catch (errors) {
        this.wrongUserOrPassword = true;
      }
    },
  },
};
</script>
